import { render, staticRenderFns } from "./ResultReportForm.vue?vue&type=template&id=1113ee5c&"
import script from "./ResultReportForm.vue?vue&type=script&lang=ts&"
export * from "./ResultReportForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports